import { Modal } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { checkIfIsLocked } from "../../../utilities/tableUtils";
import Button from "../../Button";
import Overlay from "../../Overlay";
import HeaderOverlay from "../../Project/Header";
import Title from "../../Project/Title";
import AddWritingForm from "./AddWritingForm";
import lockRedIcon from "../../../assets/img/icons/table/toggleSpecial.svg";

const ModalComponent = ({
  id,
  open,
  headerContent,
  handleClose,
  data,
  content,
  ...rest
}) => {
  const [showModal, setShowModal] = useState(false);
  const [lastFocusedInput, setLastFocusedInput] = useState("designation");

  const updateInputFocus = useCallback(
    () =>
      setTimeout(() => {
        let inputToFocus;
        if (data?.emptyDateTreso) {
          inputToFocus = document.getElementsByName("dateTreso")[0];
        } else if (data?.emptyDateCompta) {
          inputToFocus = document.getElementsByName("dateCompta")[0];
        } else {
          inputToFocus = document.getElementsByName(lastFocusedInput)[0];
        }

        if (inputToFocus) {
          inputToFocus.focus();
        }
      }, 100),
    [data?.emptyDateCompta, data?.emptyDateTreso, lastFocusedInput]
  );

  useEffect(() => {
    if (lastFocusedInput && open) {
      updateInputFocus();
    }
    if (!open) {
      setLastFocusedInput("designation");
    }
  }, [open, lastFocusedInput, data?.emptyDateCompta, data?.emptyDateTreso]);

  useEffect(() => {
    if (!showModal) updateInputFocus();
  }, [showModal, data?.emptyDateTreso, data?.emptyDateCompta]);

  const cancelChanges = (id) => {
    handleClose(id);
    setShowModal(false);
  };

  const handleInputFocus = (inputName) => setLastFocusedInput(inputName);
  const handleModalContinue = () => setShowModal(false);

  const { project } = useSelector((state) => state.project);

  const disableBasedOnComptaMode =
    (data?.edit || data?.isVentilation) &&
    checkIfIsLocked(data?.element, "compta", project);

  const disableBasedOnTresoMode =
    (data?.edit || data?.isVentilation) &&
    checkIfIsLocked(data?.element, "treso", project);

  const disableBasedOnMode =
    disableBasedOnComptaMode && disableBasedOnTresoMode;
  const getModalTitle = () => {
    if (data?.isVentilation) {
      return "Ventilation d'une écriture";
    }
    if (!data?.edit || data?.isCreateByDuplication) {
      return "Nouvelle écriture";
    }
    if (data?.isImported) {
      return "Ecriture importée à classer !";
    }
    if (data?.type === "all") {
      return "Modifier une série d'écritures récurrentes";
    }
    return "Modifier une écriture";
  };
  const getLockedMessage = () => {
    if (disableBasedOnMode) {
      return "Cette écriture est rattachée à une période verrouillée en mode tréso et en mode résultat";
    }
    if (disableBasedOnComptaMode) {
      return "Cette écriture est rattachée à une période verrouillée en mode résultat";
    }
    if (disableBasedOnTresoMode) {
      return "Cette écriture est rattachée à une période verrouillée en mode tréso";
    }
    return null;
  };

  const lockedMessage = getLockedMessage();

  return (
    <>
      <Modal
        destroyOnClose
        title={getModalTitle()}
        open={open}
        onCancel={() => {
          setShowModal(true);
        }}
        focusTriggerAfterClose={false}
        centred
        style={{ top: 30 }}
        className="add-writing-modal"
        footer={false}
        closable={false}
      >
        {lockedMessage ? (
          <div className="disable-based-on-mode">
            <p style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <img src={lockRedIcon} alt="locked" className="lock-icon" />
              <span>{lockedMessage}</span>
            </p>
          </div>
        ) : null}
        <AddWritingForm
          onCancel={() => handleClose(id)}
          edit={data?.edit}
          handleInputFocus={handleInputFocus}
          element={data?.element}
          originalCategoryId={data?.originalCategoryId}
          selectedCategory={data?.selectedCategory}
          projectId={data?.projectId}
          isAction={data?.isAction}
          date={data?.date}
          type={data?.type}
          emptyDateTreso={data?.emptyDateTreso}
          emptyDateCompta={data?.emptyDateCompta}
          dateTresoDndSpecial={data?.dateTresoDndSpecial}
          dateComptaDndSpecial={data?.dateComptaDndSpecial}
          isCreateByDuplication={data?.isCreateByDuplication}
          isImported={data?.isImported}
          isImportedAfterDnd={data?.isImportedAfterDnd}
          action={data?.action}
          aiCategorization={data?.aiCategorization}
          isVentilation={data?.isVentilation}
        />
      </Modal>

      {showModal && (
        <Overlay show={open} closable={true} onClick={() => cancelChanges(id)}>
          <HeaderOverlay showlogo>
            <Title
              isDelete
              projectTitle={
                "Lorsque vous saisissez dans une fenêtre type formulaire, vous devez valider la saisie par le bouton « valider »."
              }
              subTitle={"Vous n'avez pas terminé votre saisie!"}
            />
            <div className="verify-inputs-popup">
              <Button
                className={"button-verify-inputs"}
                text={"Abandonner"}
                onClick={() => cancelChanges(id)}
              />

              <Button
                text={"Reprendre la saisie "}
                onClick={handleModalContinue}
                className={
                  "action-button  agree-action-button button-verify-inputs"
                }
                iconClassName={"delete-icon"}
              />
            </div>
          </HeaderOverlay>
        </Overlay>
      )}
    </>
  );
};

export default ModalComponent;
